var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3D900",
    strokeWidth: 3,
    d: "M1.5 1.5h157v157H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 79.3L52 52v56l56-28.7z",
    fill: "#E2D72F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDE2MCAxNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeD0iMS41IiB5PSIxLjUiIHdpZHRoPSIxNTciIGhlaWdodD0iMTU3IiBzdHJva2U9IiNFM0Q5MDAiIHN0cm9rZS13aWR0aD0iMyIgLz4KICA8cGF0aCBkPSJNMTA4IDc5LjNMNTIgNTJWMTA4TDEwOCA3OS4zWiIgZmlsbD0iI0UyRDcyRiIgLz4KPC9zdmc+";
export { SvgIconPlay as ReactComponent };